import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import GlobalHeader from "../components/GlobalHeader";


export default function AppLayout() {
  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-content" style={{ display:"flex", flexDirection:"column", flex:1 }}>
        <GlobalHeader>
          <Outlet />
        </GlobalHeader>
      </div>
    </div>
);
}